module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/schedule-5-5a55a4ac41b9c421e1118c26efa9ddb8.jpg";